export const NC_KEEP_YOUR_SMART_REPAY = 'NC_KEEP_YOUR_SMART_REPAY';
export const NC_MANDATE_LIST = 'NC_MANDATE_LIST';
export const NC_REASON_FOR_CANCELLATION = 'NC_REASON_FOR_CANCELLATION';
export const NC_SUBMITTED_REQUEST = 'NC_SUBMITTED_REQUEST';
